
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(281|327|378|756|864)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
